import {Component, HostBinding, Input, OnDestroy, OnInit} from "@angular/core";
import {FUINavigationLink, FUINavigationLinkAvailability} from "./navigation-link.model";
import {FUINavigationService} from "../navigation.service";
import {NavigationEnd, Router} from "@angular/router";
import {Location} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-navigation-link",
    templateUrl: "./navigation-link.component.html",
    styleUrls: ["./navigation-link.component.scss"],
    standalone: false
})
export class FUINavigationLinkComponent implements OnInit, OnDestroy {
    FUINavigationLinkAvailability = FUINavigationLinkAvailability;

    @Input() link: FUINavigationLink;

    @HostBinding("class.mobile") private get mobile() {
        return this.navigationService.useMobileNav();
    };

    private subscriptions: Subscription = new Subscription();

    constructor(private location: Location,
                public navigationService: FUINavigationService,
                private router: Router) {
    }

    ngOnInit() {
        if (this.location.path().indexOf(this.link.href) > -1) {
            this.navigationService.setActiveLink(this.link);
        }

        this.subscriptions.add(this.router.events.subscribe(
            (event) => {
                if (event instanceof NavigationEnd) {
                    if (this.location.path().indexOf(this.link.href) > -1) {
                        this.navigationService.setActiveLink(this.link);
                    }
                }
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
